export type SelectorOptionT<T> = {
  tag: 'option'
  key: T
  disabled: boolean
  label: string
  dataTest?: string
}

type SelectorGroupT<T> = {
  tag: 'group'
  key: string
  label: string
  options: Array<SelectorOptionT<T>>
}

export type SelectorItemT<T> = SelectorOptionT<T> | SelectorGroupT<T>

export function createSelectorGroupAsItem<T>(
  key: string,
  label: string,
  options: Array<SelectorOptionT<T>>
): SelectorItemT<T> {
  return {tag: 'group', key, label, options}
}

export function createSelectorOptionAsItem<T>(
  key: T,
  label: string,
  disabled: boolean = false,
  dataTest: string | null = null
): SelectorItemT<T> {
  const dataTestAttr = dataTest === null ? {} : {dataTest}
  return {tag: 'option', key, disabled, label, ...dataTestAttr}
}

export function createSelectorOption<T>(
  key: T,
  label: string,
  disabled: boolean = false,
  dataTest: string | null = null
): SelectorOptionT<T> {
  const dataTestAttr = dataTest === null ? {} : {dataTest}
  return {tag: 'option', key, disabled, label, ...dataTestAttr}
}
